import type { RouteRecordRaw } from 'vue-router'
import { PERMISSIONS } from '@/core/permissions/constants'

export const userRoutes: RouteRecordRaw[] = [
  {
    path: '/users',
    name: 'users',
    component: () => import('@/modules/users/views/UserListView.vue'),
    meta: {
      permission: PERMISSIONS.USER.LIST,
    },
  },
]
